export const loadQuotePage = () => import('@/pages/quote');

export function preloadQuotePage() {
  void loadQuotePage();
}